import {useEffect, useRef} from 'react';
import {useRouter} from 'next/router';
import cn from 'clsx';

export const VariantSelector = ({
  parentVariant,
  selectedVariant,
  selectedOptions,
  setSelectedOptions
}) => {
  const router = useRouter();
  const prevSkuRef = useRef(undefined);
  const variantOptions = parentVariant?.variantOptions;

  const updateUrl = () => {
    if (selectedVariant?.sku && selectedVariant?.sku !== prevSkuRef.current) {
      const currentPath = router.pathname;
      const currentQuery = router.query;
      const newQuery = {...currentQuery, sku: selectedVariant?.sku};
      router.replace(
        {
          pathname: currentPath,
          query: newQuery
        },
        undefined,
        {shallow: true}
      );
      prevSkuRef.current = selectedVariant?.sku;
    }
  };

  useEffect(() => {
    updateUrl();
  }, [selectedVariant?.sku, router]);

  if (!variantOptions) {
    return null;
  }

  return (
    <div className={`flex flex-col my-4 lg:mb-6`}>
      {variantOptions.map((option) => {
        const name = option.name;
        let optionValues = [...option.values];

        if (name === 'Coil Configuration') {
          optionValues = sortCoilConfiguration(optionValues);
        }

        const selectedValue = selectedOptions[name];

        return (
          <OptionWrapper
            key={name}
            name={name}
            optionValues={optionValues}
            selectedValue={selectedValue}
            setSelectedOptions={setSelectedOptions}
          />
        );
      })}
    </div>
  );
};

const OptionWrapper = ({name, optionValues, selectedValue, setSelectedOptions}) => (
  <div className={'mb-4 last:mb-0'}>
    <div className={'mb-2 text-md font-bold uppercase'}>{name}</div>
    <div className={'flex gap-2'}>
      {optionValues.map((value) => {
        const isSelected = value === selectedValue;

        const classes = cn({
          'border border-neutral-400 font-medium px-2 py-1 lg:px-4 lg:py-2 hover:bg-gray-100 cursor-pointer rounded': true,
          'border-neutral-500 bg-neutral-200 hover:bg-neutral-200': isSelected
        });

        return (
          <div
            key={`${name}-${value}`}
            className={classes}
            onClick={() => {
              setSelectedOptions((prev) => ({...prev, [name]: value}));
            }}>
            {value}
          </div>
        );
      })}
    </div>
  </div>
);

const sortCoilConfiguration = (values) => {
  if (!values || !values?.length) return;
  return values.sort((a, b) => {
    if (a === 'Dual 1 Ω') return -1;
    if (b === 'Dual 1 Ω') return 1;
    if (a === 'Dual 2 Ω') return -1;
    if (b === 'Dual 2 Ω') return 1;
    if (a === 'Dual 4 Ω') return 1;
    if (b === 'Dual 4 Ω') return -1;
    return 0;
  });
};
